import Reflux from "reflux";
import { singletonActions } from "logic/singleton";
const FailureActions = singletonActions(
  "FailureProcessings",
  () => Reflux.createActions({
    updateFailureConfig: { asyncResult: true },
    loadFailureConfig: { asyncResult: true },
    loadFailureProcessingOverview: { asyncResult: true }
  })
);
export default FailureActions;
